// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/common/Navbar/Navbar';
import Footer from './components/common/Footer/Footer';
import About from './pages/About/About';
import Activities from "./pages/Activities/Activities";
import Gallery from "./pages/Gallery/Gallery";
import { LanguageProvider } from './context/language/LanguageContext';

// Import other components
import Home from './pages/Home/Home';
import AcceptingRules from './pages/AcceptingRules/AcceptingRules';
import Requirements from './pages/Requirements/Requirements';
import AcceptanceSeason from './pages/AcceptanceSeason/AcceptanceSeason';
import Guardians from "./pages/Guardians/Guardians";
import Punishment from './pages/Punishment/Punishment';
import Languages from './pages/Languages/Languages';
import BasicEducation from './pages/BasicEducation/BasicEducation';
import PidakatBase from './pages/PidakatBase/PidakatBase';
import Pre from './pages/PidakatBase/Pre/Pre';
import Primary from './pages/PidakatBase/Primary/Primary';
import Pidakat from './pages/Pidakat/Pidakat';
import Saddha from './pages/PidakatBase/Saddha/Saddha';
import Upaca from "./pages/PidakatBase/Upaca/Upaca";

function App() {
    return (
        <LanguageProvider>
            <Router>
                <div className="app">
                    <Navbar />
                    <main className="main-content">
                        <Routes>
                            <Route path="/" element={<Home />} />

                            <Route path="/new-monks/accepting-rules" element={<AcceptingRules />} />
                            <Route path="/new-monks/requirements" element={<Requirements />} />
                            <Route path="/new-monks/acceptance-season" element={<AcceptanceSeason />} />
                            <Route path="/administration/guardians" element={<Guardians />} />
                            <Route path="/administration/punishments" element={<Punishment />} />
                            <Route path="/administration/languages" element={<Languages />} />

                            {/* About Routes */}
                            <Route path="/about" element={<About />} />
                            <Route path="/about/pali" element={<About />} />
                            <Route path="/about/tharmanay-kyaw" element={<About />} />
                            <Route path="/about/sar-wah" element={<About />} />
                            <Route path="/about/foreign-monks" element={<About />} />
                            <Route path="/about/apad" element={<About />} />
                            <Route path="/about/future-monks" element={<About />} />
                            <Route path="/about/meditation" element={<About />} />

                            {/* Education Routes */}
                            <Route path="/education/basic" element={<BasicEducation />} />
                            <Route path="/education/pidakat-base" element={<PidakatBase />} />
                            <Route path="/education/pidakat-base/saddha" element={<Saddha />} />
                            <Route path="/education/pidakat-base/pre" element={<Pre />} />
                            <Route path="/education/pidakat-base/primary" element={<Primary />} />
                            <Route path="/education/pidakat-base/upaca" element={<Upaca />} />
                            <Route path="/education/pidakat" element={<Pidakat />} />

                            {/* Media Routes */}
                            <Route path="/activities" element={<Activities />} />
                            <Route path="/gallery" element={<Gallery />} />
                        </Routes>
                    </main>
                    <Footer />
                </div>
            </Router>
        </LanguageProvider>
    );
}

export default App;